$(function() {

	$('.form-fill-hint-label').on('mouseenter', function(event) {
		showFillHintMessage($(this).parents('.form-fill-hint-field-container'), $(this).data('fill-hint-message'));
	});


	$('.form-fill-hint-label').on('mouseleave', function(event) {
		hideFillHintMessage();
	});

});


// Показывает подсказку для поля jqField
function showFillHintMessage(jqFieldContainer, message) {
	var jqField = jqFieldContainer.find('input, textarea').eq(0),
		height = jqField.outerHeight(),
		width = jqField.outerWidth(),
		form = jqField.parents('form'),
		top = jqField.offset().top - form.offset().top + height + 1,
		left = jqField.offset().left - form.offset().left,
		hintContainer = form.find('.form-fill-hint-container');

	if (hintContainer.length == 0) {
		form.append('<div class="form-fill-hint-container"><div class="form-fill-hint"></div></div>');
		hintContainer = form.find('.form-fill-hint-container');
	}

	if (jqField.prop('tagName') == 'INPUT') hintContainer.css('width', width);
	else hintContainer.removeAttr('style');

	hintContainer.addClass('visible').css({
		top: top,
		left: left
	}).find('.form-fill-hint').html(message);
}


// Скрывает сообщение об ошибке
function hideFillHintMessage() {
	$('.form-fill-hint-container').removeAttr('style').removeClass('visible');
}